import { faPen } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/shared/Button.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import Spinner from 'components/shared/Spinner';
import { StyledSpinnerContainer } from 'components/shared/Spinner.styled';
import { LoginTypeTextDict } from 'context/logged-user/loggeduser.context';
import {
  StyledFieldset,
  StyledLegend
} from 'features/portal/v2/components/StyledForm';
import { ChangePasswordConfirmModal } from './confirm';
import { usePortalSettingsAccountPassword } from './PortalSettingsAccountPassword.hooks';
import { PortalSettingsAccountPasswordProps } from './PortalSettingsAccountPassword.types';

export const PortalSettingsAccountPassword: React.FC<
  PortalSettingsAccountPasswordProps
> = ({ manfrediteEmail }) => {
  const {
    t,
    loginType,
    featureEnabled,
    isConfirmModalOpened,
    closeConfirmModal,
    openConfirmModal
  } = usePortalSettingsAccountPassword();

  return (
    <StyledFieldset>
      <StyledLegend>
        {t('portal-settings.account.form.password.title')}
      </StyledLegend>

      {!loginType || !featureEnabled ? (
        <StyledSpinnerContainer>
          <Spinner />
        </StyledSpinnerContainer>
      ) : (
        <>
          {loginType === 'user_pass' ? (
            <Button
              type="button"
              variant="secondary"
              sizes="sm"
              onClick={openConfirmModal}
            >
              <FontAwesomeIcon icon={faPen} />
              <span>
                {t(
                  'portal-settings.account.form.password.actions.change-password'
                )}
              </span>
            </Button>
          ) : (
            <p>
              <HtmlTrans
                ns="portal-settings"
                i18nKey="portal-settings.account.form.password.no-user-pass"
                components={{
                  platformLink: <a href={LoginTypeTextDict[loginType].url} />
                }}
                values={{
                  platform: LoginTypeTextDict[loginType].name
                }}
              />
            </p>
          )}

          <ChangePasswordConfirmModal
            manfrediteEmail={manfrediteEmail}
            isOpen={isConfirmModalOpened}
            close={closeConfirmModal}
          />
        </>
      )}
    </StyledFieldset>
  );
};
